import React from 'react';
import TagItem from './TagItem';

const TagCloud = ({ tags, onTagClick, searchQuery }) => {
  // Фильтруем теги: проверяем, начинается ли название тега с поискового запроса
  const filteredTags = tags.filter(tag => {
    if (!searchQuery.trim()) return true; // Если поиск пустой, показываем все теги
    
    const tagName = tag.name.toLowerCase();
    const query = searchQuery.toLowerCase();
    
    // Проверяем, начинается ли название тега с поискового запроса
    return tagName.startsWith(query);
  });

  if (filteredTags.length === 0) {
    return (
      <div id="tagSearchCloud" className="no-results">
        <p>Теги не найдены</p>
      </div>
    );
  }

  return (
    <div id="tagSearchCloud">
      {filteredTags.map((tag, index) => (
        <TagItem 
          key={index} 
          name={tag.name} 
          color={tag.color} 
          apiUrl={process.env.REACT_APP_API_URL} 
          id={tag.id} 
          onClick={onTagClick} 
        />
      ))}
    </div>
  );
};

export default TagCloud;